<ng-container *ngIf="!equipmentProviderInActive">
<div class="roadmap__container background-color-white">
    <div class="roadmap">
        <div class="roadmap__header">
            <span class="roadmap__header-title">{{content?.interactiveElementHeader}}</span>
            <span class="roadmap__header-text m-t-xs-regular outer" [innerHTML]="content?.interactiveElementText"></span>
        </div>
        <div class="roadmap__points" id="roadmap">
            <div id="orange1" *ngIf="!showInfo1 && isCurrentPoint(0)" (touchend)="toggleShowInfoMobile(1)" (mouseenter)="toggleShowInfo1()" class="container__upper-point">
                <div class="upperPoint container__upper-point-number">
                    01
                </div>
                <div class="container__upper-point-text">
                    {{content?.cards[0].title}}
                </div>
            </div>
            <div id="showInfo1" *ngIf="showInfo1 && isCurrentPoint(0)" (touchend)="toggleShowInfoMobile(1)" (mouseleave)="toggleShowInfo1()" class="show-info">
                <div class="show-info__number">
                    01
                </div>
                <div class="show-info__title">
                    {{content?.cards[0].title}}
                </div>
                <div class="show-info__text">
                    {{content?.cards[0].text}}
                </div>
            </div>
            <img *ngIf="breakpoints.large || breakpoints.extraLarge" class="points-arrow1" [src]="sharedDataService.assetsCdn('images/dotted-arrow1@3x.png')" alt="" loading="lazy">
            <div id="orange2" *ngIf="!showInfo2 && isCurrentPoint(1)" (touchend)="toggleShowInfoMobile(2)" (mouseenter)="toggleShowInfo2()" class="container__lower-point">
                <div class="upperPoint container__upper-point-number">
                    02
                </div>
                <div class="container__upper-point-text">
                    {{content?.cards[1].title}}
                </div>
            </div>
            <div id="showInfo2" *ngIf="showInfo2 && isCurrentPoint(1)" (touchend)="toggleShowInfoMobile(2)" (mouseleave)="toggleShowInfo2()" class="show-info">
                <div class="show-info__number">
                    02
                </div>
                <div class="show-info__title">
                    {{content?.cards[1].title}}
                </div>
                <div class="show-info__text">
                    {{content?.cards[1].text}}
                </div>
            </div>
            <img *ngIf="breakpoints.large || breakpoints.extraLarge" class="points-arrow2 hsfs" [src]="sharedDataService.assetsCdn('images/dotted-arrow2@3x.png')" alt="" loading="lazy">
            <div id="orange3" *ngIf="!showInfo3 && isCurrentPoint(2)" (touchend)="toggleShowInfoMobile(3)" (mouseenter)="toggleShowInfo3()" class="container__upper-point">
                <div class="upperPoint container__upper-point-number">
                    03
                </div>
                <div class="container__upper-point-text">
                    {{content?.cards[2].title}}
                </div>
            </div>
            <div id="showInfo3" *ngIf="showInfo3 && isCurrentPoint(2)" (touchend)="toggleShowInfoMobile(3)" (mouseleave)="toggleShowInfo3()" class="show-info">
                <div class="show-info__number">
                    03
                </div>
                <div class="show-info__title">
                    {{content?.cards[2].title}}
                </div>
                <div class="show-info__text">
                    {{content?.cards[2].text}}
                </div>
            </div>
            <img *ngIf="breakpoints.large || breakpoints.extraLarge" class="points-arrow3" [src]="sharedDataService.assetsCdn('images/dotted-arrow3@3x.png')" alt="" loading="lazy">
            <div id="orange4" *ngIf="!showInfo4 && isCurrentPoint(3)" (touchend)="toggleShowInfoMobile(4)" (mouseenter)="toggleShowInfo4()" class="container__lower-point">
                <div class="upperPoint container__upper-point-number">
                    04
                </div>
                <div class="container__upper-point-text">
                    {{content?.cards[3].title}}
                </div>
            </div>
            <div id="showInfo4" *ngIf="showInfo4 && isCurrentPoint(3)" (touchend)="toggleShowInfoMobile(4)" (mouseleave)="toggleShowInfo4()" class="show-info">
                <div class="show-info__number">
                    04
                </div>
                <div class="show-info__title">
                    {{content?.cards[3].title}}
                </div>
                <div class="show-info__text">
                    {{content?.cards[3].text}}
                </div>
            </div>
        </div>
    </div>
    <div class="background-img">
        <img *ngIf="!breakpoints.extraSmall" [src]="content?.interactiveElementBackgroundImage.data.attributes.url" [alt]="content?.interactiveElementBackgroundImage.alternativeText" loading="lazy">
        <img *ngIf="breakpoints.extraSmall" [src]="content?.mobileInteractiveElementBackgroundImage.data.attributes.url" [alt]="content?.mobileInteractiveElementBackgroundImage.alternativeText" loading="lazy">
    </div>

    <app-component-controls *ngIf="breakpoints.extraSmall" [navigationStyle]="'dots'" [dotsColor]="'white'" [currentIndex]="currentPoint" [cutBy]="1" [elements]="[1,2,3,4]" [watchElementId]="'roadmap'" [animation]="'slide'" (navigateToEvent)="currentPoint = $event"></app-component-controls>
</div>
</ng-container>
<ng-container *ngIf="equipmentProviderInActive">
    <div class="roadmap__container background-color-white">
        <div class="roadmap">
            <div class="roadmap__header-hsfs">
                <span class="roadmap__header-hsfs-title" style="font-weight: 500; font-size: 49px !important;line-height: 41.75px">{{content?.interactiveElementHeader}}
                </span>
                <div class="roadmap__header-hsfs-addtitle" style="font-size: 29px !important; line-height: 23.86px;   padding-top: 0.8rem;">Get more with the <b> PracticePay<sup style="vertical-align: 0em;">&trade;</sup> </b> App.

                </div> 
                <div *ngIf="breakpoints.large|| breakpoints.extraLarge" class="roadmap__header-hsfs-text m-t-xs-regular outer" [innerHTML]="content?.interactiveElementText"></div>
                <div *ngIf="breakpoints.small || breakpoints.extraSmall" class="roadmap__header-hsfs-text m-t-xs-regular outer roadmap mob" [innerHTML]="content?.interactiveElementText"></div>
            </div>
            <div class="roadmap__points" id="roadmap">
                <div id="orange1" class="hsfs" *ngIf="!showInfo1 && isCurrentPoint(0)" (touchend)="toggleShowInfoMobile(1)" (mouseenter)="toggleShowInfo1()" class="container__upper-point">
                    <div class="upperPoint container__upper-point-number">
                        01
                    </div>
                    <div class="container__upper-point-text">
                        {{content?.cards[0].title}}
                    </div>
                </div>
                <div id="showInfo1" *ngIf="showInfo1 && isCurrentPoint(0)" (touchend)="toggleShowInfoMobile(1)" (mouseleave)="toggleShowInfo1()" class="show-info ">
                    <div class="show-info__number">
                        01
                    </div>
                    <div class="show-info__title">
                        {{content?.cards[0].title}}
                    </div>
                    <div class="show-info__text" style="line-height: 1.5rem;" [innerHTML]="content?.cards[0].text">
                      
                    </div>
                </div>
                <img *ngIf="breakpoints.large || breakpoints.extraLarge" class="points-arrow1 hsfs" [src]="sharedDataService.assetsCdn('images/dotted-arrow1@3x.svg')" alt="" loading="lazy">
                <div id="orange2" class="hsfs" *ngIf="!showInfo2 && isCurrentPoint(1)" (touchend)="toggleShowInfoMobile(2)" (mouseenter)="toggleShowInfo2()" class="container__lower-point hsfs">
                    <div class="upperPoint container__upper-point-number">
                        02
                    </div>
                    <div class="container__upper-point-text">
                        {{content?.cards[1].title}}
                    </div>
                </div>
                <div id="showInfo2" *ngIf="showInfo2 && isCurrentPoint(1)" (touchend)="toggleShowInfoMobile(2)" (mouseleave)="toggleShowInfo2()" class="show-info equip">
                    <div class="show-info__number">
                        02
                    </div>
                    <div class="show-info__title">
                        {{content?.cards[1].title}}
                    </div>
                    <div class="show-info__text" style="line-height: 1.5rem;" [innerHTML]="content?.cards[1].text">
                    </div>
                </div>
                <img *ngIf="breakpoints.large || breakpoints.extraLarge" class="points-arrow2 hsfs" [src]="sharedDataService.assetsCdn('images/dotted-arrow2@3x.svg')" alt="" loading="lazy"> 
                <div id="orange3" class="hsfs" *ngIf="!showInfo3 && isCurrentPoint(2)" (touchend)="toggleShowInfoMobile(3)" (mouseenter)="toggleShowInfo3()" class="container__upper-point hsfs">
                    <div class="upperPoint container__upper-point-number">
                        03
                    </div>
                    <div class="container__upper-point-text">
                        {{content?.cards[2].title}}
                    </div>
                </div>
                <div id="showInfo3" *ngIf="showInfo3 && isCurrentPoint(2)" (touchend)="toggleShowInfoMobile(3)" (mouseleave)="toggleShowInfo3()" class="show-info">
                    <div class="show-info__number">
                        03
                    </div>
                    <div class="show-info__title">
                        {{content?.cards[2].title}}
                    </div>
                    <div class="show-info__text" style="line-height: 1.5rem;margin-left: 0.4rem;" [innerHTML]="content?.cards[2].text">
                     
                    </div>
                </div>
               <img *ngIf="breakpoints.large || breakpoints.extraLarge" class="points-arrow3 hsfs" [src]="sharedDataService.assetsCdn('images/dotted-arrow3@3x.svg')" alt="" loading="lazy"> 
                <div id="orange4" class="hsfs" *ngIf="!showInfo4 && isCurrentPoint(3)" (touchend)="toggleShowInfoMobile(4)" (mouseenter)="toggleShowInfo4()" class="container__lower-point hsfs">
                    <div class="upperPoint container__upper-point-number">
                        04
                    </div>
                    <div class="container__upper-point-text">
                        {{content?.cards[3].title}}
                    </div>
                </div>
                <div id="showInfo4" *ngIf="showInfo4 && isCurrentPoint(3)" (touchend)="toggleShowInfoMobile(4)" (mouseleave)="toggleShowInfo4()" class="show-info">
                    <div class="show-info__number">
                        04
                    </div>
                    <div class="show-info__title">
                        {{content?.cards[3].title}}
                    </div>
                    <div class="show-info__text" style="line-height: 1.5rem;" [innerHTML]="content?.cards[3].text">
                     
                    </div>
                </div>
            </div>
            <div *ngIf="breakpoints.large || breakpoints.extraLarge" class="flexItemsDiv getapp flex-column  a-items-center" style="width:24rem;">
                  <div class="column-100 j-content-center font-xs-small font-lg-medium">
                    <div class="headerDownloadToday equipgetapp header-xs-extra-small font-lg-medium font-color-dark m-b-small" [ngStyle]="{'font-size': '1.625rem','line-height': '1.491rem'}">
                       Get the <span class="equipbold">PracticePay<sup style="vertical-align: 0em;">&trade;</sup></span> App
                    </div>
                    <div class="column-90 a-self-center j-content-between m-b-xs-regular m-b-lg-smaller">
                        <!-- <a target="_blank" href="https://apps.apple.com/us/app/icreditworks/id1455870277"><span class="icon icon_badge-apple"></span></a>
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.iCreditWorks.icw"><span class="icon icon_badge-google"></span></a> -->

                        <a target="_blank" href="https://apps.apple.com/us/app/henry-schein-practicepay/id6575345209"><span style="width:7.375rem;height:3rem" class="icon  icon_badge-apple-equip"></span></a>
                        <a  target="_blank" style="padding-left:10px" href="https://play.google.com/store/apps/details?id=com.iCreditWorks.icw.practicepay"><span  style="width:7.375rem;height:3rem" class="icon icon_badge-google-equip"></span></a>
    


                    </div>
                    <div class="botTextLow font-extra-small justify-content-lg-start" style="padding-right: 5rem;">
                        Google Play and the Google Play logo are trademarks of <br> Google LLC. Apple, the Apple logo, and iPhone are <br> trademarks of Apple, Inc., registered in the U.S.
                    </div>

                    <div class="textBttomDiv2 font-xs-smaller font-lg-extra-small m-t-small" style="height: 0.7rem;padding-right: 12rem;">
                        *All loans issued by WebBank
                    </div>
                </div>
            </div>
         </div>

        <div class="background-img">
            <img *ngIf="!breakpoints.extraSmall" [src]="content?.interactiveElementBackgroundImage.data.attributes.url" [alt]="content?.interactiveElementBackgroundImage.alternativeText" loading="lazy">
            <img *ngIf="breakpoints.extraSmall" [src]="content?.mobileInteractiveElementBackgroundImage.data.attributes.url" [alt]="content?.mobileInteractiveElementBackgroundImage.alternativeText" loading="lazy">
        </div>
    
        <app-component-controls *ngIf="breakpoints.extraSmall" [navigationStyle]="'dots'" [dotsColor]="'white'" [currentIndex]="currentPoint" [cutBy]="1" [elements]="[1,2,3,4]" [watchElementId]="'roadmap'" [animation]="'slide'" (navigateToEvent)="currentPoint = $event"></app-component-controls>
    </div>
    </ng-container>
    